export default __webpack_public_path__ + "static/media/z.1d3c3a27.mp4";